import { ICartEntry } from '@rbi-ctg/menu';
import { CartEntryType } from 'utils/cart/types';

import { ILimitProps, IMinimumProps } from './types';

const determineLimit = ({ maxLimit, maxCateringLimit, isCatering }: ILimitProps): number =>
  isCatering ? maxCateringLimit : maxLimit;

const determineMinimum = ({ minLimit, minCateringLimit, isCatering }: IMinimumProps): number =>
  isCatering ? minCateringLimit : minLimit;

const isOfferType = (type: CartEntryType) => /^offer/i.test(type);

const replaceEntryArrayItem = (array: ICartEntry[], newEntry: ICartEntry) => {
  const index = array.findIndex(entry => String(entry.cartId) === String(newEntry.cartId));
  return index !== -1
    ? [...array.slice(0, index), newEntry, ...array.slice(index + 1)]
    : [...array, newEntry];
};

export { determineLimit, determineMinimum, isOfferType, replaceEntryArrayItem };
